import blockBgColorField from '../fields/blockBgColorField';

export default {
  value: 'new_arrivals',
  label: 'New Arrivals',
  fields: [blockBgColorField]
};
